var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpoInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 10,
    stroke: "#fff",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6159 14.7898C11.099 15.7966 9.84053 16.3 9.12171 15.8115C8.95128 15.6957 8.80428 15.5487 8.68847 15.3783C8.2 14.6595 8.70339 13.401 9.71017 10.8841C9.92491 10.3472 10.0323 10.0788 10.217 9.86819C10.264 9.81453 10.3145 9.76401 10.3682 9.71695C10.5788 9.53228 10.8472 9.42491 11.3841 9.21017C13.901 8.20339 15.1595 7.7 15.8783 8.18847C16.0487 8.30428 16.1957 8.45128 16.3115 8.62171C16.8 9.34053 16.2966 10.599 15.2898 13.1159C15.0751 13.6528 14.9677 13.9212 14.783 14.1318C14.736 14.1855 14.6855 14.236 14.6318 14.283C14.4212 14.4677 14.1528 14.5751 13.6159 14.7898Z",
    stroke: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5008,
    cy: 12.0008,
    r: 1.2,
    stroke: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoInactive);
export default __webpack_public_path__ + "static/media/expoInactive.21c8a1b9a7b657118fa416d113228534.svg";
export { ForwardRef as ReactComponent };